import Api from "@/services/Api";

export default {
    getBotonesControl(scope, roleId) {
        return Api().get("botones/control/" + scope, {
            params: { roleId }
        });
    },
    saveBotonesControl(scope, botones, userId, roleId) {
        return Api().put("botones/control/" + scope, {
            botones,
            userId,
            scope,
            roleId
        });
    }
};
